import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { PageHero } from "../components/blocks";
import { Reveal } from "../components/motion/Reveal";
import { CommodityCard } from "../components/CommodityCard";
import { IMAGES } from "../content/defaultContent";

export default function Commodities() {
  const { content } = useLanguage();
  const s = content.home.commoditiesSection;
  return (
    <div data-testid="commodities-page">
      <PageHero
        overline={content.ui.nav.commodities}
        title={s.title}
        subtitle={s.body}
        image={IMAGES.coffee}
      />
      <section className="bg-brand-beige py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {content.commodities.map((item, i) => (
              <Reveal key={item.slug} variant="up" delay={i * 0.12}>
                <CommodityCard item={item} index={i} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
